import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=d315021a&scoped=true"
import script from "./register-form.vue?vue&type=script&lang=js"
export * from "./register-form.vue?vue&type=script&lang=js"
import style0 from "./register-form.vue?vue&type=style&index=0&id=d315021a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d315021a",
  null
  
)

export default component.exports